export class BuildingItemModel {
  constructor(
    public id: string, 
    public name: string, 
    public numberOfAnnotations: number,
    public isGraphic: boolean,
    public isExported: boolean,
    public address: string,
  ) {}
}
